import React, { Component } from 'react';
import { withStyles  } from '@mui/styles';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import CircularProgress from '@mui/material/CircularProgress';

const styles = (/* theme */) => ({
  root: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center'
  },
  card: {
    position: 'absolute',
    height: 'auto',
    top: 'calc(50% - 6%)',
    left: 'calc(50% - 6%)',
    padding: 30
  },
  progress: {
    marginLeft: 4
  },
  text: {
    textAlign: 'center',
    marginTop: 20
  }
});

class Spinner extends Component {

  render() {
    const { classes, text } = this.props;
    return(
      <div>
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
        >
          <Grid item>
            <Card className={classes.card}>
              <CircularProgress className={classes.progress} color="primary" />
              <Typography className={classes.text} color="primary">
                { text || 'Loading' }
              </Typography>
            </Card>
          </Grid>
        </Grid>
      </div>
    )
  }
}

export default withStyles(styles)(Spinner);
